exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;visibility:hidden;z-index:300;transform:translateZ(0);background-color:rgba(0,0,0,.7);will-change:transform;transition:opacity .3s linear,visibility .3s linear}.overlay.is-visible{opacity:1;visibility:visible}", ""]);

// exports
